import * as Api from "./api";

const VALIDATE_CODE_API_URL = "/twofactor/validatecode";
const SEND_CODE_API_URL = "/twofactor/sendcode";

export function validateCode(data) {
	return Api.postToApi(VALIDATE_CODE_API_URL, data);
}

export function sendCode() {
	return Api.postToApi(SEND_CODE_API_URL);
}
